module.exports = __webpack_public_path__ + "static/media/benchmark-bkg-4.0032c290.svg";